import React from "react";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { ClientReviewSummaryModalProps } from "./types";
import ClientReviewSummaryModal from "./components/Dialog";

export function openReviewSummaryModal(masterAccountId: string, masterAccountName:string, reviewId: string) {
    return createConfirmation<ClientReviewSummaryModalProps, any>(confirmable((props) => (
        <ClientReviewSummaryModal {...props} />
    )))({
        dialogId: 'client_reviews_summary',
        masterAccountId,
        masterAccountName,
        reviewId
    });
}